import React, {useImperativeHandle} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {CheckBox} from '@rneui/themed';
import {createStyles} from '../../../utils/createStyles';
import {useNavigation} from '@react-navigation/native';

interface AgreeNegotiateProps {
  customStyle?: object;
}

export interface AgreeNegotiateRef {
  getCheckState: () => boolean;
}

const AgreeNegotiate = React.forwardRef<AgreeNegotiateRef, AgreeNegotiateProps>(
  (props: AgreeNegotiateProps, ref) => {
    const navigation = useNavigation();
    const [checked, setChecked] = React.useState(false);
    const toggleCheckbox = () => setChecked(!checked);
    useImperativeHandle(ref, () => ({
      getCheckState: () => checked,
    }));
    return (
      <View style={{...styles.flexWrap, ...props.customStyle}}>
        <CheckBox
          containerStyle={styles.agreeCt}
          checked={checked}
          onPress={toggleCheckbox}
          // Use ThemeProvider to make change for all checkbox
          size={15}
          iconType="material-community"
          checkedIcon="checkbox-marked"
          uncheckedIcon="checkbox-blank-outline"
          checkedColor="red"
        />
        <View style={styles.textWrap}>
          <Text style={styles.text}>我已经阅读并同意</Text>
          <TouchableOpacity
            activeOpacity={0.6}
            onPress={() => navigation.navigate('FuWuDocument')}>
            <Text style={styles.text2}>《用户服务协议》</Text>
          </TouchableOpacity>
          <Text style={styles.text}>和</Text>
          <TouchableOpacity
            activeOpacity={0.6}
            onPress={() => navigation.navigate('YinSiDocument')}>
            <Text style={styles.text2}>《用户隐私政策》</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  },
);
export default AgreeNegotiate;
const styles = createStyles({
  text: {
    color: '#666',
    fontSize: '1rem',
  },
  text2: {
    color: '#6658FF',
    fontSize: '1rem',
  },
  agreeCt: {
    backgroundColor: 'transparent',
    padding: '0.4rem',
    paddingRight: 0,
    margin: 0,
  },
  flexWrap: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingRight: '1rem',
    alignItems: 'center',
  },
  textWrap: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
